export default __webpack_public_path__ + "static/imgs/remove-5b8bbde4f1e195e859ccbc3f11e35f63.svg";